import type { MouseEventHandler } from 'react';
import { memo, useCallback } from 'react';

import { type SessionAction, SessionActionType } from '@/components/chat-app/hooks/useChatSession';
import { CONTAINER_EVENT, INNER_EVENT } from '@/components/chat-app/utils/utils';
import type { ReactClassNameInterface } from '@/types/common';

import SvgClear from '../../../svg/clear';

export interface IProps extends ReactClassNameInterface {
  action: SessionAction;
}

function SessionUserAction(props: IProps) {
  const { action, className } = props;

  const { type, content } = action;

  const handleClear: MouseEventHandler<HTMLDivElement> = useCallback((e): void => {
    e.stopPropagation();
    dispatchEvent(new Event(CONTAINER_EVENT.RESTART_SESSION));
  }, []);

  // 点击 「Resend」 按钮
  const handleResend: MouseEventHandler<HTMLDivElement> = useCallback((e): void => {
    e.stopPropagation();
    dispatchEvent(new Event(INNER_EVENT.RESEND_MSG));
  }, []);

  return (
    <>
      {type === SessionActionType.ERROR_WITHOUT_ACTION && content?.length !== 0 && (
        <div className={className}>
          <div
            className={
              'inline-block box-border text-sm whitespace-normal max-w-[--cc-max-width-content] text-[--cc-bg-error-system-content] break-words'
            }
          >
            {content}
          </div>
        </div>
      )}

      {/* 此处放session或服务不可用提示 */}
      {type === SessionActionType.ERROR && content?.length !== 0 && (
        <div className={className}>
          <div
            className={
              'inline-block box-border text-sm whitespace-normal max-w-[--cc-max-width-content] text-[--cc-bg-error-system-content] break-words'
            }
          >
            {content}
          </div>
          <div
            className={
              'flex items-center w-36 mt-3 text-red-400 cursor-pointer py-[5px] px-4 border border-solid border-[#ff7875] rounded-2xl text-[#ff7875]'
            }
            onClick={handleClear}
          >
            <SvgClear color="#ff7875" height="14px" width="14px" />
            <span className={'ml-1 text-xs leading-5'}>Restart Session</span>
          </div>
        </div>
      )}
      {/* 此处放session或服务不可用提示 */}
      {type === SessionActionType.WARNING && content?.length !== 0 && (
        <div className={className}>
          <div
            className={
              'inline-block box-border text-sm whitespace-normal max-w-[--cc-max-width-content] text-[--cc-bg-warning-system-content] break-words'
            }
          >
            {content}
          </div>
          <div
            className={
              'flex items-center justify-center w-20 mt-3 text-yellow-600 cursor-pointer py-[5px] px-0 border border-solid border-[#faad14] text-[#faad14] rounded-full'
            }
            onClick={handleResend}
          >
            <span className={'text-xs leading-5'}>Resend</span>
          </div>
        </div>
      )}
    </>
  );
}

export default memo(SessionUserAction);
